export default __webpack_public_path__ + "products-filter.v17/ico_check.c8f7689f.svg";